<template>
  <SeoPage page-key="seoLuganoTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'SeoLuganoTicinoPage'
})
</script>

